import { JxsComponent } from '@jxs/component';

class JxsAnnouncement extends JxsComponent {

  #swiper = null;

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.init();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#swiper?.destroy(true, true);
  }

  init() {
    const config = {
      loop: true,
      autoplay: false,
      rewind: false,
      slidesPerView: 1
    };
    if (this.getDataset('autoplay')) {
      config.autoplay = {
        delay: this.getDataset('autoplaySec', 5) * 1000
      }
    }
    this.#swiper = new Swiper(this.refs.swiper, config);
  }
}
customElements.define('jxs-announcement', JxsAnnouncement);